import React from 'react';
import { Link } from 'react-router-dom';
import BBContent from 'components/BBContent';

import articles from './articles';

const findArticle = (name) => {
  return articles.find(a => a.name.startsWith(name));
}

const HelpArticle = ({ match }) => {
  const article = findArticle(match.params.article)
  return [
    <div className="breadcrumb">
      <div className="container">
        <Link to="/help">Ayuda</Link>
        <span> / </span>
        <span className="active">{article.title}</span>
      </div>
    </div>,
    <section>
      <div className="container">
        <article>
          <BBContent content={article.content}/>
        </article>
      </div>
    </section>
  ]
}

export default HelpArticle